import Image from 'next/image';
import { Wrapper, LiquidityBackground, Title, APY, Label } from './LeverageLiquidity.styles';
import Link from '@components/common/Link';
import CountUp from 'react-countup';
import { useLpAPY } from '@components/store/getters';

const formatNumberWithCommas = (value: Number) => {
  return value.toLocaleString();
};

export default function Liquidity() {
  const lpApy = useLpAPY();
  return (
    <LiquidityBackground>
      <Wrapper>
        <Image src="/home/liquidity.svg" alt="" width={453} height={324} />
        <div>
          <Title type="h1">Earn - Providing Liquidity</Title>
          <p>
            Provide liquidity to our 3CRV/lvUSD Curve Pool and enjoy a sustainable &apos;Top of the Market&apos; APY
            with lower risk.
          </p>
          {!!lpApy && (
            <APY type="h1">
              <CountUp useEasing duration={3} end={lpApy} formattingFn={formatNumberWithCommas} decimals={2} />%
            </APY>
          )}
          <Label>Current Curve Pool APY</Label>
          <p>
            <Link href="/earn" variant="outline">
              Provide Liquidity
            </Link>
          </p>
          <p>
            <Link target="_blank" href="https://docs.archimedesfi.com/" variant="thick">
              User Docs
            </Link>
          </p>
        </div>
      </Wrapper>
    </LiquidityBackground>
  );
}
